import { type ReleaseToService } from '../ReleaseToService/types';
import { type SquawkDeferral, type SquawkDeferralAndReleases } from './types';

export function injectReleasesToDeferrals(
    deferrals: SquawkDeferral[],
    releases: ReleaseToService[]
): SquawkDeferralAndReleases[] {
    return deferrals.map((deferral): SquawkDeferralAndReleases => {
        return {
            ...deferral,
            releases: releases.filter((r) => r.deferralId === deferral.id),
        };
    });
}
